import React from 'react'
import { useTranslation } from 'react-i18next'
import { StatusCaption } from './StatusCaption'

export function SingleStateItemContent ({ status }) {
  const { t } = useTranslation()

  return (
    <StatusCaption
      variant={status.status === 'DONE' ? 'dark' : 'light'}>
      {t(`order.details.progressBar.${status.type}`)}
    </StatusCaption>
  )
}
